import actions from './actions';
import initialState from '../initialState';

export const iccaReducer = (state = initialState.iccaState, action) => {
    switch (action.type) {
        case actions.OPEN_ICCA_STATE:
            return { ...state, openIccaModal: action.state.openIccaModal };
        case actions.ICCA_ID_STATE:
            return { ...state, iccaId: action.state.iccaId };
        default:
            return state;
    }
};

export default iccaReducer;
